import { render, staticRenderFns } from "./SfjsIframe.vue?vue&type=template&id=340e6fee&scoped=true"
import script from "./SfjsIframe.vue?vue&type=script&lang=js"
export * from "./SfjsIframe.vue?vue&type=script&lang=js"
import style0 from "./SfjsIframe.vue?vue&type=style&index=0&id=340e6fee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340e6fee",
  null
  
)

export default component.exports